import { render, staticRenderFns } from "./QueryFrame.vue?vue&type=template&id=a8a768c2&scoped=true&"
import script from "./QueryFrame.vue?vue&type=script&lang=js&"
export * from "./QueryFrame.vue?vue&type=script&lang=js&"
import style0 from "./QueryFrame.vue?vue&type=style&index=0&id=a8a768c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a768c2",
  null
  
)

export default component.exports